export default {
    list: {
        title: "Contenedores",
        subtitle: "Gestiona tus contenedores de envío",
        newContainer: "Nuevo Contenedor",
        viewMap: "Ver Mapa",
        loading: "Cargando contenedores...",
        clearFilters: "Limpiar Filtros",
        backToDashboard: "Volver al Dashboard",
        filters: {
            searchPlaceholder: "Buscar por número de contenedor, ruta...",
            statusPlaceholder: "Filtrar por estado",
            riskLevelPlaceholder: "Filtrar por nivel de riesgo",
            documentStatusPlaceholder: "Filtrar por estado de documentos",
            shippingCompanyPlaceholder: "Filtrar por compañía de envío",
            commodityPlaceholder: "Filtrar por mercancía",
            originPlaceholder: "Filtrar por origen",
            portPlaceholder: "Filtrar por puerto de llegada",
            allStatuses: "Todos los estados",
            allLevels: "Todos los niveles",
            allCompanies: "Todas las compañías",
            allCommodities: "Todas las mercancías",
            allOrigins: "Todos los orígenes",
            allPorts: "Todos los puertos",
        },
        table: {
            title: "Contenedores",
            description: "Lista completa de contenedores",
            updating: "Actualizando...",
            headers: {
                containerNumber: "Número de Contenedor",
                route: "Ruta",
                progress: "Progreso",
                status: "Estado",
                documentStatus: "Documentos",
                riskLevel: "Riesgo",
                value: "Valor",
                createdAt: "Creado",
                actions: "Acciones",
            },
            view: "Ver",
            edit: "Editar",
            delete: "Eliminar",
            noContainers: {
                title: "No se encontraron contenedores",
                message: "Intenta modificar los filtros de búsqueda",
                emptyMessage: "Comienza creando tu primer contenedor",
                createFirst: "Crear el primer contenedor",
            },
        },
        charts: {
            riskLevels: "Distribución de Niveles de Riesgo",
            containerStatus: "Distribución de Estado de Contenedores",
            documentStatus: "Distribución de Estado de Documentos",
        },
    },
    form: {
        title: "Nuevo Contenedor",
        editTitle: "Editar Contenedor",
        subtitle: "Crear un nuevo contenedor de envío",
        editSubtitle: "Editar detalles del contenedor",
        loading: "Cargando contenedor...",
        back: "Atrás",
        sections: {
            containerInfo: "Información del Contenedor",
            route: "Ruta",
            order: "Pedido",
            receiver: "Destinatario",
            value: "Valor",
        },
        fields: {
            containerNumber: "Número de Contenedor",
            containerNumberPlaceholder: "TCLU1234567",
            status: "Estado",
            statusPlaceholder: "Selecciona estado",
            routeFrom: "Desde",
            routeFromPlaceholder: "Nueva York, EE.UU.",
            routeTo: "Hasta",
            routeToPlaceholder: "Londres, Reino Unido",
            eta: "ETA",
            shippingCompany: "Compañía de Envío",
            shippingCompanyPlaceholder: "Selecciona compañía",
            receiver: "Destinatario",
            receiverPlaceholder: "Selecciona destinatario",
            amount: "Importe",
            amountPlaceholder: "125000",
            currency: "Moneda",
            currencyPlaceholder: "Selecciona moneda",
            orderId: "ID de Pedido",
            orderIdPlaceholder: "Ingresa o selecciona ID de Pedido",
            orderIdSelectExisting: "Seleccionar de pedidos existentes",
            orderIdEnterManually: "Ingresar manualmente",
        },
        actions: {
            cancel: "Cancelar",
            save: "Guardar Cambios",
            create: "Crear Contenedor",
        },
        errors: {
            generic: "Ocurrió un error al guardar el contenedor",
            allFieldsRequired: "Todos los campos son obligatorios",
            amountInvalid: "El importe debe ser un número mayor que 0",
            containerExists: "Ya existe un contenedor con este número",
        },
        noReceivers: "No hay destinatarios activos disponibles. Invita un nuevo destinatario para continuar.",
        selectReceiver: "Seleccionar Destinatario",
        notesOptional: "Notas (opcional)",
        notesPlaceholder: "Añade una nota para el destinatario...",
        selectedReceiver: "Destinatario Seleccionado",
        name: "Nombre",
        email: "Email",
        country: "País",
        sendInvite: "Enviar Invitación",
    },
    detail: {
        back: "Volver a Contenedores",
        backToList: "Volver a la lista",
        loading: "Cargando detalles del contenedor...",
        notFound: {
            title: "Contenedor no encontrado",
            message: "El contenedor solicitado no existe o no tienes permiso para verlo.",
        },
        actions: {
            uploadDocuments: "Subir Documentos",
            triage: "Triage",
            edit: "Editar",
            share: "Compartir",
            delete: "Eliminar",
        },
        confirmDeleteContainer: {
            title: "Eliminar Contenedor",
            message: "¿Estás seguro de que deseas eliminar el contenedor {{containerNumber}}? Esta acción no se puede deshacer.",
            cancel: "Cancelar",
            delete: "Eliminar",
        },
        tabs: {
            overview: "Vista General",
            info: "Información",
            documents: "Documentos",
            timeline: "Línea de Tiempo",
        },
        info: {
            containerInfo: "Información del Contenedor",
            route: "Ruta",
            shipper: "Expedidor",
            receiver: "Destinatario",
            from: "Desde",
            to: "Hasta",
            created: "Creado",
            expandMap: "Expandir mapa",
            collapseMap: "Contraer mapa",
            fields: {
                status: "Estado",
                progress: "Progreso",
                riskLevel: "Nivel de Riesgo",
                documentStatus: "Estado de Documentos",
                eta: "ETA",
                value: "Valor",
                shippingCompany: "Compañía de Envío",
                country: "País",
            },
        },
        documents: {
            title: "Documentos",
            headers: {
                name: "Nombre",
                type: "Tipo",
                status: "Estado",
                uploaded: "Subido",
                actions: "Acciones",
            },
            actions: {
                view: "Ver",
                review: "Revisar",
                history: "Historial",
                download: "Descargar",
                delete: "Eliminar",
            },
            confirmDelete: {
                title: "Eliminar Documento",
                message: "¿Estás seguro de que quieres eliminar este documento? Esta acción no se puede deshacer.",
                cancel: "Cancelar",
                delete: "Eliminar",
            },
            uploadInDevelopment: "Funcionalidad de carga de documentos en desarrollo",
            uploadDocument: "Subir Documento",
            discrepancies: {
                allCongruent: {
                    title: "Todos los documentes son consistentes",
                    message:
                        "Las discrepancias se han resuelto con éxito. Todos los atributos extraídos de los documentos están ahora alineados y verificados.",
                    resetButton: "Restablecer discrepancias",
                    viewTriage: "Ver Triage",
                },
                detected: {
                    title: "Posibles discrepancias en los datos del documento",
                    message:
                        "Detectamos inconsistencias entre algunos atributos extraídos de los documentos de este contenedor. Recomendamos proceder con el triage para verificarlos y corregirlos.",
                    goToTriage: "Ir al Triage de Documentos",
                },
            },
        },
        timeline: {
            title: "Eventos de la Línea de Tiempo",
            events: {
                containerCreated: "Contenedor creado",
                statusChanged: "Estado cambiado",
                documentsUploaded: "Documentos subidos",
                progressUpdated: "Progreso actualizado",
            },
            statusChangedFrom: "Estado cambiado de",
            to: "a",
            documentsUploadedCount: "documentos subidos",
            progressUpdatedTo: "Progreso actualizado a",
        },
    },
    triage: {
        title: "Triage de Documentos",
        subtitle: "Contenedor",
        resolveWithAI: "Resolver con IA",
        tabs: {
            matrix: "Matriz",
            visual: "Visual",
            raw: "Datos Sin Procesar",
        },
        matrix: {
            attribute: "Atributo",
            ok: "OK",
            ko: "KO",
        },
        visual: {
            document: "Documento",
            check: "Verificar",
            ok: "OK",
        },
        raw: {
            json: "JSON",
            highlightDiscrepancies: "Resaltar discrepancias",
        },
        modal: {
            title: "Resolviendo discrepancias con IA",
            analyzing: "Analizando y corrigiendo atributos extraídos…",
            completed: "Resolución completada",
            allResolved: "Todas las discrepancias se han resuelto. Puedes cerrar esta ventana para ver los resultados actualizados.",
            close: "Cerrar",
        },
    },
    upload: {
        title: "Subir Documentos",
        subtitle: "Subir documentos para el contenedor",
        loading: "Cargando...",
        notFound: {
            title: "Contenedor no encontrado",
            message: "El contenedor solicitado no existe.",
            backToList: "Volver a la lista",
        },
        fileTooLarge: "El archivo {fileName} es demasiado grande. Máximo 10MB permitido.",
        selectAtLeastOne: "Selecciona al menos un archivo para subir",
        documentType: "Tipo de Documento",
        uploadSelected: "Subir Seleccionados",
        cancel: "Cancelar",
        confirmUpload: "Confirmar Subida",
        uploadInProgress: "Subida en progreso",
        uploadCompleted: "Subida completada",
        returnToDocuments: "Volver a Documentos",
        removeFile: "Eliminar archivo",
        selectFiles: "Seleccionar Archivos",
        selectedFiles: "Archivos Seleccionados",
        file: "archivo",
        files: "archivos",
        document: "documento",
        documents: "documentos",
        container: "Contenedor",
        uploading: "Subiendo...",
        uploadedSuccessfully: "Subido con éxito",
        documentsUploadedSuccess: "¡Documentos subidos con éxito!",
        documentsNowAvailable: "documento(s) han sido subidos y ahora están disponibles en la sección Documentos.",
        goToDocuments: "Ir a Documentos",
        confirmUploadTitle: "Confirmar Subida de Documentos",
        unknownTypeWarning:
            'Algunos documentos tienen tipo "Documento Desconocido". Esto significa que el sistema no pudo identificar automáticamente el tipo de documento.',
        unknownTypeDocuments: "Documentos con tipo Desconocido:",
        proceedAnyway: "Aún puedes proceder con la subida. Los documentos pueden clasificarse manualmente más tarde.",
        proceedWithUpload: "Proceder con la Subida",
    },
    worldMap: {
        title: "Mapa de Rutas Mundiales",
        backToList: "Volver a la lista",
        updateInfo: "El sistema verifica y actualiza las posiciones de los contenedores periódicamente.",
        lastUpdate: "Última actualización",
        containerDetails: "Detalles del Contenedor",
        viewFullDetails: "Ver detalles completos",
        showContainers: "Mostrar Contenedores",
        containerList: "Contenedores en el Mapa",
        containerSingular: "contenedor",
        containerPlural: "contenedores",
    },
    receiver: {
        title: "Contenedores Recibidos",
        subtitle: "Gestiona contenedores recibidos de expedidores",
        loading: "Cargando contenedores...",
        searchPlaceholder: "Buscar por ID de contenedor, ruta o expedidor...",
        shipperPlaceholder: "Filtrar por expedidor",
        allShippers: "Todos los expedidores",
        description: "Lista completa de contenedores recibidos",
        headers: {
            containerId: "ID de Contenedor",
            shipper: "Expedidor",
            route: "Ruta",
            shippingCompany: "Compañía de Envío",
            progress: "Progreso",
            eta: "ETA",
            status: "Estado",
            docStatus: "Estado Doc",
            riskLevel: "Nivel de Riesgo",
            value: "Valor",
            actions: "Acciones",
        },
        noContainers: {
            title: "No se encontraron contenedores",
            message: "Intenta modificar los filtros de búsqueda",
            emptyMessage: "Aún no se han recibido contenedores",
        },
        viewDetails: "Ver Detalles",
        shipper: "Expedidor",
    },
};
